import React from 'react';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import TuneOutlined from '@mui/icons-material/TuneOutlined';

type Props = {
  onOpenChiTiet?: () => void;
};

const CanvasPageToolbar: React.FC<Props> = ({ onOpenChiTiet }) => (
  <Stack direction="row" spacing={0.5} alignItems="center" sx={{ width: '100%', gap: 0.5 }}>
    <Typography variant="caption" color="text.secondary">
      Trang
    </Typography>
    <Box sx={{ flexGrow: 1 }} />
    <Tooltip title="Chi tiết — mở / đóng panel cài đặt">
      <IconButton size="small" color="primary" onClick={() => onOpenChiTiet?.()}>
        <TuneOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  </Stack>
);

export default CanvasPageToolbar;
